import { clearLoginData, onLoginUserReset } from "../Store/Slices/loginSlice";
import {
  setBusinessOnboardingComplete,
  setIsLoggedOut,
} from "../Store/Slices/utilitySlice";
import { onRegisterDataReset } from "../Store/Slices/registerSlice";
import { persistor, store } from "../Store/Store";

const clearLoginDataFunction = async () => {
  store.dispatch(onLoginUserReset());
  store.dispatch(clearLoginData());
  store.dispatch(setIsLoggedOut());
  store.dispatch(onRegisterDataReset());
  store.dispatch(setBusinessOnboardingComplete(false));
  await persistor.purge();
  sessionStorage.clear();
  localStorage.clear();
};
const isBusinessUser = () => {
  const loginData = store.getState().utilityReducer;

  return loginData?.userData?.user_type === "business" ? true : false;
};
const isUser = () => {
  const loginData = store.getState().utilityReducer.loginData;
  return loginData?.userData?.user_type === "user" ? false : true;
};
const isLoggedIn = () => {
  const isLoggedIn = store.getState().utilityReducer.isLoggedIn;
  return isLoggedIn;
};
const capsFirstLetter = (string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1);
};
const getTags = (tags) => {
  if (Array.isArray(tags)) return tags;

  if (typeof tags === "string") {
    return tags.replace(/'/g, "").split(",");
  }

  return [];
};

const tranformBusinessData = (data, venue = false, all = false) => {

  return data
    ?.filter((item) =>
      all
        ? true
        : venue
          ? item.business_type === "venue"
          : item.business_type === "vendor",
    )
    ?.map((item) => {
      const isVenueItem = all ? item.business_type === "venue" : venue;
      const source = all
        ? item.business_type === "venue"
          ? item.venue
          : item.vendor
        : venue
          ? item.venue
          : item.vendor;
      const coverImage =
        item.images?.find((img) => img.image_type === "cover")?.image_url ||
        item.images?.[0]?.image_url ||
        "";
      return {
        average_rating: item.average_rating,
        number_of_reviews: item.number_of_reviews,
        reviews_list: item.reviews,
        id: item.id,
        top_rank: item?.top_rank,
        name: item.business_name,
        image: coverImage,
        email: item.email,
        type: isVenueItem
          ? (source?.venue_type ?? item.business_type)
          : (source?.vendor_type ?? item.business_type),
        ...(all && { businessType: item.business_type }),
        address: source?.full_address ?? null,
        images: [
          coverImage,
          ...(item.images
            ?.filter((img) => img.image_type !== "cover")
            ?.map((img) => img.image_url) || []),
        ],
        city: item.city,
        capacity: isVenueItem
          ? {
              min: source?.capacity_min ?? null,
              max: source?.capacity_max ?? null,
            }
          : null,
        phone: item.phone,
        number_of_halls: isVenueItem ? source?.number_of_halls : null,
        description: source?.description ?? null,
        tags: item?.tags === String ? [item?.tags] : (item?.tags ?? []),
        amenities: isVenueItem
          ? (source?.amenities ?? [])
        : source?.amenities === String
            ? [source?.amenities]
            : (source?.amenities ?? []),
        pricePerPlate: {
          original: "₹" + (item.price_max ?? 0),
          discounted: "₹" + (item.price_min ?? 0),
        },
        ...(!isVenueItem
          ? {
              package_price: item.price_min,
              vendor_type: source?.vendor_type,
              years_of_experience: source?.years_of_experience,
              service_radius_km: source?.service_radius_km,
              willing_to_travel: source?.willing_to_travel,
            }
          : {}),
      };
    });
};
const formatDate = (date, showtime = false) => {
  date = new Date(date);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formattedDate = `${day}-${month}-${year} ${showtime ? date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() : ""}`;
  return formattedDate;
};
const findImageForCategory = (businessesList, category, selectedCity) => {
  const categoryId = category
    ?.toLowerCase()
    ?.replace(`in ${selectedCity.toLowerCase()}`, "")
    ?.trim()
    ?.replace(/s$/, "");

  const vendor = businessesList.find(
    (c) =>
      c?.business_type === "vendor" &&
      c.vendor?.vendor_type?.toLowerCase() === categoryId?.toLowerCase(),
  );

  return (
    vendor?.images?.find((img) => img.image_type === "cover")?.image_url || ""
  );
};

/** Amenities from API may be a string, array of strings, or array of objects — normalize for display. */
function normalizeAmenitiesList(amenities) {
  if (amenities == null) return [];
  if (Array.isArray(amenities)) {
    return amenities
      .map((a) => {
        if (a == null) return "";
        if (typeof a === "string") return a.replace(/'/g, "").trim();
        if (typeof a === "object") {
          const label = a.name ?? a.label ?? a.amenity ?? a.title;
          if (label != null) return String(label).replace(/'/g, "").trim();
        }
        return String(a).replace(/'/g, "").trim();
      })
      .filter(Boolean);
  }
  if (typeof amenities === "string") {
    return amenities
      .replace(/'/g, "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [];
}

export {
  clearLoginDataFunction,
  isBusinessUser,
  isUser,
  isLoggedIn,
  tranformBusinessData,
  capsFirstLetter,
  formatDate,
  findImageForCategory,
  getTags,
  normalizeAmenitiesList,
};
